module.exports = __webpack_public_path__ + "media/img/pages/companies/zhaw-59140a9ad3ec724216300b954823f8de.png";